import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styles from "./AppShowcase.module.css";

const AppShowcase = () => {
  const { t } = useTranslation();
  const settings = useSelector((state) => state.settings.data);
  const appStoreUrl = settings?.promotion || "https://apps.apple.com";
  const googlePlayUrl = settings?.promotion || "https://play.google.com";

  const features = [
    {
      icon: "bi-broadcast",
      text: t("appShowcase.feature1", "Continuous Live Radio Streaming"),
    },
    {
      icon: "bi-shield-lock-fill",
      text: t("appShowcase.feature2", "Fast Google/Apple Login & OTP Verification"),
    },
    {
      icon: "bi-truck",
      text: t("appShowcase.feature3", "Secure Book Purchasing & Global Delivery"),
    },
  ];

  return (
    <section className={styles.sectionWrapper}>
      <div className={styles.bgLight}></div>
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div className={styles.contentBox}>
              <span className={styles.subtitle}>
                {t("appShowcase.subtitle", "GET THE APP")}
              </span>

              <h2 className={styles.title}>
                {t("appShowcase.title", "Takween in Your Pocket")}
              </h2>

              <p className={styles.description}>
                {t(
                  "appShowcase.description",
                  "Tune in to live radio, listen to podcasts, and browse your audiobook and physical library all in one place with a single tap on your mobile device."
                )}
              </p>

              <ul className={`${styles.featureList} d-flex justify-content-center align-items-center flex-wrap gap-4 mb-5`}>
                {features.map((feat, index) => (
                  <li key={index} className={styles.featureItem}>
                    <div className={styles.iconWrapper}>
                      <i className={`bi ${feat.icon}`}></i>
                    </div>
                    <span>{feat.text}</span>
                  </li>
                ))}
              </ul>

              <div className={`${styles.downloadGroup} d-flex justify-content-center gap-3 flex-wrap`}>
                <a
                  href={appStoreUrl}
                  className={styles.downloadBadge}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-apple"></i>
                  <div className={styles.badgeText}>
                    <span>{t("hero.downloadAppStore", "Download on the")}</span>
                    <strong>App Store</strong>
                  </div>
                </a>

                <a
                  href={googlePlayUrl}
                  className={styles.downloadBadge}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-google-play"></i>
                  <div className={styles.badgeText}>
                    <span>{t("hero.downloadGooglePlay", "GET IT ON")}</span>
                    <strong>Google Play</strong>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(AppShowcase);
